import {Injectable} from '@angular/core';
import {HttpHelper} from '@shared/helpers/http.helper';
import {ResponseArray} from '@shared/interfaces/http.interface';
import {API_STANDARDS_TYPES__SYSTEM, getEndpoint} from '@core/constants/api';
import {StandardType} from '@core/interfaces';

@Injectable({
  providedIn: 'root'
})
export class StandardTypesSystemService extends HttpHelper {
  getList(): Promise<ResponseArray<StandardType>> {
    return this.GetAll<StandardType>(getEndpoint(API_STANDARDS_TYPES__SYSTEM));
  }
}
